import React from 'react';
// eslint-disable-next-line import/no-internal-modules
import { renderToStaticMarkup } from 'react-dom/server';
import { SelectFieldOption } from 'components/organisms/tasks/field-value/option';

/* TODO:: Translate label if needed in the future */
export const None = renderToStaticMarkup(
  <SelectFieldOption option={{ color: 'gray', label: 'None', value: -1 }} />,
);
